module.exports = __webpack_public_path__ + "img/phone-pluska.464c48fd.png";